import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { productListingDispatcher } from '../../../../redux/product-listing/product-listing.dispatchers';
import { productListingSelector, currentCategorySelector, productAttributesSelector, colorFamilySelector, pricingSelector, isLoadingSelector, isEmptyProductListSelector, productionTimeSelector, minQuantitySelector, embellishmentMethodSelector, maxPrintColorsSelector, imprintLocationsAmountSelector, headerTitleSelector, isFilterOpenedSelector, categoriesFilterFacetsSelector, shouldShowFiltersPanelSelector, currentParentCategorySelector, withAnimationSelector } from '../../../../redux/product-listing/product-listing.selectors';
import { boxAndInventorySelector, shopCustomColorsSelector } from './tenant-specific-selectors';
import { ProductListingComponent } from './product-listing';
const mapStateToProps = createStructuredSelector({
  productListing: productListingSelector,
  isFilterPopupOpen: isFilterOpenedSelector,
  currentCategory: currentCategorySelector,
  currentParentCategory: currentParentCategorySelector,
  productAttributes: productAttributesSelector,
  colorFamily: colorFamilySelector,
  pricing: pricingSelector,
  isLoading: isLoadingSelector,
  isEmptyProductList: isEmptyProductListSelector,
  productionTime: productionTimeSelector,
  minQuantity: minQuantitySelector,
  embellishmentMethod: embellishmentMethodSelector,
  boxAndInventory: boxAndInventorySelector,
  maxPrintColors: maxPrintColorsSelector,
  imprintLocationsAmount: imprintLocationsAmountSelector,
  headerTitle: headerTitleSelector,
  categories: categoriesFilterFacetsSelector,
  shouldShowFiltersPanel: shouldShowFiltersPanelSelector,
  withAnimation: withAnimationSelector,
  customColors: shopCustomColorsSelector
});
export default connect(mapStateToProps, productListingDispatcher)(ProductListingComponent);